import Markdown from "react-markdown";
import { Layout, Typography, theme, Button } from "antd";
import { ReactNode, useRef, useState } from "react";
import { Flex } from "src/components/Flex";
import {
  Contributors,
  ContributorsAvatarComponent,
} from "../../../Contributors";

export function SummaryPanel(props: {
  title: string;
  description?: string;
  contentComponent?: ReactNode;
  siderComponent?: ReactNode;
  className?: string;
}) {
  const { token } = theme.useToken();
  return (
    <Layout
      hasSider
      style={{
        backgroundColor: token.colorBgLayout,
        borderRadius: 10,
        marginBottom: 32,
        minHeight: 75,
      }}
    >
      <Layout.Content
        style={{
          backgroundColor: "transparent",
          padding: 16,
        }}
      >
        <Typography.Title level={4}>{props.title}</Typography.Title>
        {props.contentComponent || (
          <GenericContentSection
            description={props.description}
            className={props.className}
          />
        )}
      </Layout.Content>
      <Layout.Sider
        style={{
          padding: 16,
          backgroundColor: "transparent",
          borderLeft: `solid 1px ${token.colorBgBase}`,
          color: token.colorText,
        }}
      >
        {props.siderComponent || <ContributorSection />}
      </Layout.Sider>
    </Layout>
  );
}

const GenericContentSection = (props: {
  description?: string;
  className?: string;
}) => {
  const { token } = theme.useToken();
  const [expanded, setExpanded] = useState(false);
  const ref = useRef(null);
  const hasMore =
    ((ref.current as null | HTMLElement)?.scrollHeight || 0) > 150;
  return (
    <div>
      <div
        ref={ref}
        style={{
          wordBreak: "break-word",
          maxHeight: expanded ? undefined : 150,
          overflow: expanded ? "auto" : "hidden",
        }}
      >
        <Markdown
          className={props.className || "markdown"}
          skipHtml={true}
          disallowedElements={["img"]}
        >
          {props.description || ""}
        </Markdown>
      </div>
      {hasMore && (
        <div style={{ position: "relative" }}>
          {!expanded && (
            <div
              style={{
                position: "absolute",
                backgroundImage: `linear-gradient(0deg, ${token.colorBgLayout}, transparent)`,
                top: -100,
                height: 100,
                width: "100%",
              }}
            />
          )}
          <Flex centered>
            <Button
              size="small"
              type="link"
              onClick={() => setExpanded((ex) => !ex)}
            >
              {expanded ? "Collapse" : "Expand"}
            </Button>
          </Flex>
        </div>
      )}
    </div>
  );
};

const ContributorSection = () => (
  <>
    <div style={{ fontSize: 10, textTransform: "uppercase", color: "inherit" }}>
      Contributors
    </div>
    <Contributors>
      <ContributorsAvatarComponent />
    </Contributors>
  </>
);
